module.exports = __webpack_public_path__ + "img/benih-tacunan.8f30c86d.jpg";